import React, {Component} from "react";
import {Container, Row, Col, Card, CardBody, CardTitle, Button, Alert} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone,} from "react-bootstrap-table2-paginator";
import ToolkitProvider, {Search,} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import NewModal from "./NewModal";
import DeleteModal from "./DeleteModal";
import BlockModal from "./BlockModal";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {withTranslation} from "react-i18next";
import PropTypes from "prop-types";
import {usersList} from "../../store/users/actions";
import {connect} from "react-redux";
import UserPermissionsModal from "./Permissions";

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usersData: [],
      loading: false,
      error: "",
      userData: null,
      modalNew: false,
      modalBlock: false,
      modalDelete: false,
      modalPermissions: false,
    }
    this.togNew = this.togNew.bind(this)
    this.togBlock = this.togBlock.bind(this)
    this.togDelete = this.togDelete.bind(this)
    this.togPermissions = this.togPermissions.bind(this)
  }

  componentDidMount() {
    const {onUsersList} = this.props;
    onUsersList({history: this.props.history});
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        usersData: this.props.response.response ? this.props.response.response : [],
        loading: this.props.loading,
        error: this.props.error
      });
    }
  }

  togNew(data = null, action) {
    this.setState(prevState => ({
      action: action,
      userData: data,
      modalNew: !prevState.modalNew,
    }))
  }

  togDelete(data) {
    this.setState(prevState => ({
      userData: data,
      modalDelete: !prevState.modalDelete,
    }))
  }

  togBlock(data, action) {
    this.setState(prevState => ({
      action: action,
      userData: data,
      modalBlock: !prevState.modalBlock,
    }))
  }

  togPermissions(data = null) {
    this.setState(prevState => ({
      userData: data,
      modalPermissions: !prevState.modalPermissions,
    }))
  }

  render() {
    const actionFormatter = (cell, row) => {
      return (<div>
        {!row.is_fixed && <Button color="info" className="me-2 mb-2" onClick={() => this.togPermissions({id: row.id, name: row.name})}>Permissions</Button>}
        <Button color="success" className="me-2 mb-2" onClick={() => this.togNew({id: row.id, username: row.username, email: row.email}, "edit")}>Edit</Button>
        {!row.is_fixed && row.is_active && <Button color="warning" className="me-2 mb-2" onClick={() => this.togBlock({id: row.id, username: row.username}, "deactivate")}>Block</Button>}
        {!row.is_fixed && !row.is_active && <Button color="warning" className="me-2 mb-2" onClick={() => this.togBlock({id: row.id, username: row.username}, "activate")}>Unblock</Button>}
        {!row.is_fixed && <Button color="danger" className="me-2 mb-2" onClick={() => this.togDelete({id: row.id, username: row.username})}>Delete</Button>}
      </div>);
    }

    const groupsFormatter = (cell, row) => {
      return (row.groups.join(', '));
    }

    const columns = [{
      dataField: "id", text: "Id", sort: true,
    }, {
      dataField: "username", text: "Username", sort: true,
    }, {
      dataField: "email", text: "Email", sort: true,
    }, {
      dataField: "groups", text: "Groups", sort: true, formatter: groupsFormatter,
    }, {
      dataField: "created", text: "Created", sort: true,
    }, {
      dataField: "last_login", text: "Last Login", sort: true,
    }, {
      dataField: "actions", text: "Actions", sort: true, formatter: actionFormatter,
    },];

    const defaultSorted = [{
      dataField: "id", order: "asc",
    },];

    const pageOptions = {
      sizePerPage: 10, totalSize: this.state.usersData.length, custom: true, sizePerPageList: [{
        text: '10', value: 10
      }, {
        text: '25', value: 25
      }, {
        text: '50', value: 50
      }]
    };

    const {SearchBar} = Search;

    function onColumnMatch({searchText, value, column, row}) {
      if (row.username.toLowerCase().includes(searchText) ||
        row.email.toLowerCase().includes(searchText) ||
        row.groups.join(', ').toLowerCase().includes(searchText) ||
        row.created.includes(searchText) ||
        (row.last_login !== null && row.last_login.includes(searchText)))
        return true
      return false
    }

    document.title = "Users | FileJet";

    return (<React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={this.props.t("FileJet")}
            breadcrumbItem={this.props.t("Users")}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="id"
                    columns={columns}
                    data={this.state.usersData}
                  >
                    {({paginationProps, paginationTableProps}) => (<ToolkitProvider
                      keyField="id"
                      columns={columns}
                      data={this.state.usersData}
                      search={{onColumnMatch}}
                    >
                      {toolkitProps => (<React.Fragment>
                        <Row className="mb-2">
                          <Col md="8">
                            <div>
                              <Button color="primary" onClick={() => this.togNew({}, "new")}>
                                New
                              </Button>
                            </div>
                          </Col>
                          <Col md="4">
                            <div className="search-box me-2 mb-2 d-inline-block float-end">
                              <div className="position-relative">
                                <SearchBar {...toolkitProps.searchProps} placeholder="Filter"/>
                                <i className="bx bx-search-alt search-icon"/>
                              </div>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col xl="12">
                            <div className="table-responsive">
                              <BootstrapTable
                                keyField={"id"}
                                responsive
                                bordered={false}
                                striped={false}
                                defaultSorted={defaultSorted}
                                classes={"table align-middle table-nowrap"}
                                headerWrapperClasses={"thead-light"}
                                {...toolkitProps.baseProps}
                                {...paginationTableProps}
                              />
                            </div>
                          </Col>
                        </Row>

                        <Row className="align-items-md-center mt-30">
                          <Col className="inner-custom-pagination d-flex">
                            <div className="d-inline">
                              <SizePerPageDropdownStandalone {...paginationProps}/>
                            </div>
                            <div className="text-md-right ms-auto">
                              <PaginationListStandalone {...paginationProps}/>
                            </div>
                          </Col>
                        </Row>
                      </React.Fragment>)}
                    </ToolkitProvider>)}
                  </PaginationProvider>
                  {this.state.loading && (<div className="d-flex justify-content-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>)}
                  {this.state.error.length > 0 && (<div className="mt-3">
                    <Alert color="danger" role="alert">
                      {this.state.error}
                    </Alert>
                  </div>)}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {this.state.modalNew && <NewModal togModal={this.togNew} action={this.state.action} usersRefresh={this.props.onUsersList} userData={this.state.userData} history={this.props.history}/>}
          {this.state.modalBlock && <BlockModal togModal={this.togBlock} action={this.state.action} usersRefresh={this.props.onUsersList} userData={this.state.userData} history={this.props.history}/>}
          {this.state.modalDelete && <DeleteModal togModal={this.togDelete} usersRefresh={this.props.onUsersList} userData={this.state.userData} history={this.props.history}/>}
          {this.state.modalPermissions && <UserPermissionsModal togModal={this.togPermissions} userData={this.state.userData} history={this.props.history}/>}
        </Container>
      </div>
    </React.Fragment>);
  }
}

Users.propTypes = {
  response: PropTypes.any, onUsersList: PropTypes.func,
};

const mapStateToProps = ({Users}) => ({
  response: Users.responseList,
  loading: Users.loadingList,
  error: Users.errorList,
});

const mapDispatchToProps = dispatch => ({
  onUsersList: data => dispatch(usersList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Users));
